import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "flexfeed_cart_v2";

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    });
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }, [items]);

    // item shape: { workout_id, tier_id, tier_name, period, price, title, image_url }
    const addItem = (workout, tier) => {
        setItems((prev) => {
            const key = `${workout.id}:${tier.id}`;
            if (prev.find((i) => `${i.workout_id}:${i.tier_id}` === key)) return prev;
            return [
                ...prev,
                {
                    workout_id: workout.id,
                    tier_id: tier.id,
                    tier_name: tier.name,
                    period: tier.period,
                    price: tier.price,
                    title: workout.title,
                    image_url: workout.image_url,
                },
            ];
        });
        setDrawerOpen(true);
    };

    const removeItem = (workout_id, tier_id) =>
        setItems((prev) =>
            prev.filter((p) => !(p.workout_id === workout_id && p.tier_id === tier_id))
        );

    const clear = () => setItems([]);

    const total = useMemo(
        () => items.reduce((sum, it) => sum + it.price, 0),
        [items]
    );
    const count = items.length;

    return (
        <CartContext.Provider
            value={{
                items,
                addItem,
                removeItem,
                clear,
                total,
                count,
                drawerOpen,
                setDrawerOpen,
            }}
        >
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    const ctx = useContext(CartContext);
    if (!ctx) throw new Error("useCart must be used within CartProvider");
    return ctx;
};
